import { render, staticRenderFns } from "./UnderlyingLocations.vue?vue&type=template&id=275bb5bb"
import script from "./UnderlyingLocations.vue?vue&type=script&lang=js"
export * from "./UnderlyingLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports